"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstKeyFromObject = getFirstKeyFromObject;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
function getFirstKeyFromObject(obj = {}) {
  const [firstInvalidInputName] = (0, _keys.default)(obj);
  return firstInvalidInputName;
}